// utils/sessionCache.ts
// Thin sessionStorage wrapper: JSON serialize/parse plus swallowing storage
// errors (private browsing, quota, unavailable) so callers only ever see a
// cache hit or a miss — never a thrown error.

export function readSessionCache<T = any>(key: string): T | undefined {
    try {
        const raw = sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : undefined;
    } catch {
        return undefined;
    }
}

export function writeSessionCache(key: string, value: any): void {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
        // sessionStorage full or unavailable — skip caching, not fatal
    }
}
